<template>
	<div id="zjzh">
		<div class="zjzh_main">
			<div style="font-size: 16px; color: #171717">游戏平台</div>
			<div class="roll-out">
				<div
					class="roll-out-item"
					:class="item.choosed ? 'roll-in-item-active' : ''"
					v-for="(item, index) in games"
					:key="index"
					v-if="item.Status && !blacklist.find(el => el === item.GameId)"
				>
					<div class="item-left">
						<span>{{ item.CN_Name }}</span>
						<div class="item-mid" v-if="loading">
							<span style="font-size: 15px; color: #d6d6d6">加载中...</span>
						</div>
						<div class="item-mid" v-else>
							<span v-if="currentIndex == item.GameId">加载中...</span>
							<span v-else>
								{{ item.GameId | getMoney(thirdBalance) }}
							</span>
							<img
								class="refresh_money"
								src="@/static/img/zjzh/reset.webp"
								:class="refreshAni && currentIndex == item.GameId ? 'refresh_anima' : ''"
								@click="refreshMoney(item.GameId)"
							/>
						</div>

						<div class="cz_btn">
							<a @click="shiftTo($event, item.GameId)" :data-id="item.GameId" :data-name="item.CN_Name">转入</a>
							<a @click="shiftGo($event, item.GameId)" :data-id="item.GameId" :data-name="item.CN_Name">转出</a>
						</div>
					</div>
					<div class="item-right">
						<img :src="`${require(`@/static/img/userCenter/${item.Category}_${item.GameId}.webp`)}`" alt="" />
					</div>
				</div>
			</div>
		</div>

		<el-dialog :title="type == 1 ? '资金转入' : '资金转出'" :visible.sync="dialogVisible" :show-close="false">
			<div class="close_login" @click="closeDialog">
				<span></span>
			</div>

			<div class="total-money">
				<div style="display: flex; align-items: center">
					<span
						>主账号：
						<span style="font-size: 16px; color: #0e78c7">{{ userInfo.Balance }} 元</span>
					</span>
					<img
						:class="['refreesh_icon', Refresh == true ? 'refresh_anima' : '']"
						src="@/static/img/zjzh/reset.webp"
						@click="resetInfo"
					/>
				</div>
				<div style="display: flex; align-items: center">
					<span
						>{{ chooseGameText }}：
						<span style="font-size: 16px; color: #0e78c7">{{ kyqpMoney < 0 ? "..." : kyqpMoney + " 元" }}</span>
					</span>
					<img
						:class="['refreesh_icon', kyqpMoney < 0 ? 'refresh_anima' : '']"
						src="@/static/img/zjzh/reset.webp"
						@click="refreshMoney(chooseGame)"
					/>
				</div>
			</div>
			<div class="total-money" v-show="type == 1">
				<label>转入：</label>
				<input type="text" value="主账户" disabled="true" />
				<i></i>
				<input type="text" :value="chooseGameText" disabled="true" />
			</div>
			<div class="total-money" v-show="type == 2">
				<label>转出：</label>
				<input type="text" :value="chooseGameText" disabled="true" />
				<i></i>
				<input type="text" value="主账户" disabled="true" />
			</div>

			<div class="total-money">
				<span>转移金额：</span>
				<el-input class="import_input" v-model="money" type="number" placeholder="请输入转移金额" />
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="sureTransfer" :loading="transferLoading">转账</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax, postAjax4time } from "../../util/ajax.js";
import { getUserInfo } from "../../util/getdata";
import { Message } from "element-ui";

export default {
	data() {
		return {
			dialogVisible: false,
			kyqpMoney: -1, //转账窗口当前选择平台余额 小于0表示加载中
			Refresh: false, //刷新主账户余额状态
			loading: false,
			transferLoading: false,
			refreshAni: false,
			//游戏平台数组
			games: [],
			//第三方余额数据
			thirdBalance: [],
			//选择的游戏id
			chooseGame: "",
			//选择游戏中文名字
			chooseGameText: "",
			//金额
			money: "",
			//转出账户
			rollOut: [
				{ CN_Name: "转入游戏平台", choosed: false, type: "1" },
				{ CN_Name: "转出到主账户", choosed: false, type: "2" },
			],
			type: 1,
			currentIndex: null,
			blacklist: [
				18, //IM
			],
		};
	},
	computed: {
		userInfo() {
			return this.$store.state.userInfo;
		},
	},
	methods: {
		closeDialog() {
			this.dialogVisible = false;
		},
		// 刷新余额
		resetInfo() {
			this.Refresh = true;
			getUserInfo();
			setTimeout(() => {
				this.Refresh = false;
			}, 1500);
		},
		kyqpye(itemId) {
			this.thirdBalance &&
				this.thirdBalance.map(item => {
					if (itemId === item.GameId) {
						this.kyqpMoney = item.Balance;
					}
				});
			this.dialogVisible = true;
		},
		//转入
		shiftTo(e, itemId) {
			this.type = this.rollOut[0].type;
			this.chooseGame = Number(e.target.dataset.id);
			this.chooseGameText = e.target.dataset.name;
			if (this.loading) return this.$message.error("请稍后,正在加载数据");
			this.kyqpye(itemId);
		},
		//转出
		async shiftGo(e, itemId) {
			this.type = this.rollOut[1].type;
			this.chooseGame = Number(e.target.dataset.id);
			this.chooseGameText = e.target.dataset.name;
			if (this.loading) return this.$message.error("请稍后,正在加载数据");
			this.kyqpye(itemId);
		},
		//点击刷新单个余额
		refreshMoney(gameId) {
			this.currentIndex = gameId;
			this.refreshAni = true;
			let that = this;
			let url = "api/ThirdGame/GetGameBlance?game=" + gameId;
			this.kyqpMoney = -1;
			postAjax(url, null).then(data => {
				this.currentIndex = -1;
				this.refreshAni = false;
				if (data && data.IsSucess) {
					for (let i = 0, length = that.thirdBalance.length; i < length; i++) {
						if (gameId == that.thirdBalance[i].GameId) {
							that.thirdBalance[i].Balance = data.Data;
							this.kyqpMoney = data.Data;
						}
					}
				} else {
					Message.warning("获取失败余额失败,请重试");
				}
			});
		},
		//确定转账
		sureTransfer() {
			if (this.loading) {
				this.$message.error("请稍后再试!");
				return;
			}
			if (this.transferLoading) {
				return false;
			}
			if (!this.chooseGame) {
				this.$message.error("请选择游戏平台");
				return;
			}
			if (!this.money) {
				this.$message.error("请输入金额");
				return;
			}
			if (!this.checkMoney(this.type)) {
				return;
			}
			let that = this;
			let url = "api/ThirdGame/Transfer";
			let data = {
				game: this.chooseGame,
				plat: this.getGamePlat(this.games, this.chooseGame).PlatID,
				amount: this.money,
				type: this.type,
			};
			this.transferLoading = true;
			postAjax(url, data).then(function (data) {
				that.transferLoading = false;
				if (data.IsSucess && data.Data) {
					//刷新钱数
					getUserInfo();
					that.refreshMoney(that.chooseGame);
					that.$message({
						message: "转账成功",
						type: "success",
					});
					that.money = "";
				} else {
					that.$message.error(data.Message);
				}
			});
		},
		//得到选中的游戏平台
		getGamePlat(arr, id) {
			var temp = "";
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].GameId == id) {
					temp = arr[i];
				}
			}
			return temp;
		},
		//得到选中的数据
		getChoosedData(arr) {
			var temp = "";
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].choosed) {
					temp = arr[i];
				}
			}
			return temp;
		},
		//获取所有第三方游戏平台
		getGames() {
			let that = this;
			let url = "api/ThirdGame/GetGames";
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.games = that.pushGames(data.Data);
				}
			});
		},

		//给游戏平台数组加字段
		pushGames(arr) {
			for (let i = 0; i < arr.length; i++) {
				arr[i].choosed = false;
				//输入的钱
				arr[i].money = "";
				if (i === 0) {
					this.chooseGame = arr[0].GameId;
				}
			}
			return arr;
		},
		//改变转出的账户
		changeRollOut(index) {
			this.games = this.pushChoosed(this.games);
			this.games[index].choosed = !this.games[index].choosed;
		},
		//选择转入账户类型
		choosedType(index) {
			this.rollOut = this.pushChoosed(this.rollOut);
			this.rollOut[index].choosed = !this.rollOut[index].choosed;
			if (this.rollOut[index].choosed) {
				this.type = this.rollOut[index].type;
			}
		},
		//校验金额
		checkMoney(type) {
			if (type == 2) {
				let index = "";
				for (var i = 0, len = this.games.length; i < len; i++) {
					if (this.chooseGame == this.games[i].GameId) {
						index = i;
					}
				}
				if (index == "" && index != 0) {
					this.$message.error("请选择游戏平台");
					return false;
				}
				let temp = 0; //临时变量
				let money = parseInt(this.money);
				let min = parseInt(this.games[index].TMin); //最小转账金额
				let max = parseInt(this.games[index].TMax); //最大转账金额
				let haveMoney = parseInt(this.getGamesBalance(this.games[index].GameId)); //有的余额
				if (haveMoney == 0 || money == 0) {
					if (haveMoney == 0) {
						this.$message.error("余额不足");
						return false;
					}
					if (money == 0) {
						this.$message.error("最少转" + min);
						return false;
					}
				} else {
					//如果有的余额>=输入的
					if (haveMoney >= money) {
						if (parseFloat(money) < parseFloat(min)) {
							temp = min;
							this.$message.error("最少转" + min);
							return false;
						} else if (parseFloat(money) > parseFloat(max)) {
							temp = max;
							this.$message.error("最多转" + max);
							return false;
						} else {
							temp = money;
						}
					} else {
						//有的<输入的
						if (haveMoney < min) {
							temp = min;
							this.$message.error("余额不足");
							return false;
						} else if (haveMoney > max) {
							temp = max;
							this.$message.error("最多转" + max);
							return false;
						} else {
							temp = haveMoney;
						}
					}
				}
				this.money = temp;
			} else if (type == 1) {
				if (this.money < 1) {
					this.$message.error("最少转账1元");
					return false;
				} else if (this.money > this.userInfo.Balance) {
					this.$message.error("余额不足");
					return false;
				}
			} else {
				this.$message.error("请选择转账类型");
				return false;
			}
			return true;
		},
		//全部金额
		inputAll(index) {
			let temp = 0; //临时变量
			let max = parseInt(this.games[index].TMax); //最大转账金额
			let haveMoney = parseInt(this.getGamesBalance(this.games[index].GameId)); //有的余额
			if (haveMoney == 0) {
				this.games[index].money = "";
				return;
			} else {
				if (haveMoney > max) {
					temp = max;
				} else {
					temp = haveMoney;
				}
			}
			this.games[index].money = temp;
		},
		//得到当前游戏的剩余金额
		getGamesBalance(id) {
			let money = null;
			for (var i = 0, length = this.thirdBalance.length; i < length; i++) {
				if (id == this.thirdBalance[i].GameId) {
					money = this.thirdBalance[i].Balance;
				}
			}
			return money == null ? 0 : money;
		},
		//获取第三方账户余额
		async getBalance() {
			let that = this;
			that.loading = true;
			let url = "api/ThirdGame/GetGameAccAll";
			await postAjax4time(url, null, 1000 * 15).then(function (data) {
				that.loading = false;
				if (data == null || data == undefined) {
					that.$message.error("获取三方余额错误,请刷新网页重试!");
					that.kyqpLoading = false;
					return;
				}
				if (data.IsSucess) {
					that.thirdBalance = data.Data;
				}
			});
		},
		//给当前数据加选中未选中状态
		pushChoosed(arr) {
			for (var i = 0, length = arr.length; i < length; i++) {
				arr[i].choosed = false;
			}
			return arr;
		},
	},
	mounted() {
		this.getGames();
		this.getBalance();
	},
	filters: {
		//通过id得到金额
		getMoney(id, arr) {
			let money = null;
			for (var i = 0, length = arr.length; i < length; i++) {
				if (id == arr[i].GameId) {
					money = arr[i].Balance;
				}
			}
			if (money == -1) return "游戏维护中";
			return money == null ? "￥0" : `￥${money}`;
		},
		//将余额变为数组分成小数点钱和小数点后
		getMoneyArr0(arr) {
			return parseFloat(arr).toFixed(2).split(".")[0];
		},
		//将余额变为数组分成小数点钱和小数点后
		getMoneyArr1(arr) {
			return parseFloat(arr).toFixed(2).split(".")[1];
		},
	},
};
</script>
<style type="scss">
.el-loading-mask {
	background: rgba(255, 255, 255, 0.5);
}

.zjzh_main {
	padding: 15px 0px 0 0;
}

.roll-out {
	display: flex;
	justify-content: flex-start;
	margin-top: 14px;
	flex-wrap: wrap;
}

.roll-out-item {
	display: flex;
	justify-content: space-between;
	width: 232px;
	height: 105px;
	border: 1px solid #0e78c7;
	border-radius: 5px;
	margin-bottom: 20px;
}

.roll-out-item:not(:nth-child(4n + 4)) {
	margin-right: 21px;
}

.item-left {
	padding: 10px 12px 0 8px;
}

.item-left > span {
	font-size: 14px;
	color: #171717;
}

.item-mid {
	display: flex;
	align-items: center;
	height: 24px;
	margin-top: 4px;
}

.item-mid > span {
	margin-right: 5px;
	font-size: 16px;
	color: #0e78c7;
	font-weight: 400;
}

.item-right {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-right: 6px;
}

.item-right > img {
	max-width: 70px;
	max-height: 70px;
}

.cz_btn {
	width: 115px;
	display: flex;
	justify-content: space-between;
	margin-top: 7px;
}

.cz_btn a {
	display: block;
	width: 50px;
	height: 25px;
	font-size: 14px;
	line-height: 25px;
	letter-spacing: 0;
	text-align: center;
	cursor: pointer;
	border-radius: 5px;
}

.cz_btn a:nth-child(1) {
	color: #0e78c7;
	border: 1px solid #0e78c7;
}

.cz_btn a:nth-child(2) {
	color: #0e78c7;
	border: 1px solid #0e78c7;
}

.all-btn {
	width: 36%;
	height: 24px;
	text-align: center;
	line-height: 24px;
	background-color: #ffbd1e;
	font-size: 12px;
}

.total-money {
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: 15px;
	font-size: 14px;
}

.import_input {
	width: 300px !important;
}

.import_input > input {
	width: 100% !important;
}

.total-money > label {
	display: inline-block;
	width: 70px;
	text-align: right;
}

#zjzh .total-money input {
	width: 117px;
	height: 37px;

	border-radius: 5px;
	border: solid 1px #dddddd;
	font-size: 14px;
	color: #9b9b9b;
}

.import_input > input::placeholder {
	color: #9b9b9b;
}

#zjzh .total-money .el-select {
	width: 117px;
	height: 37px;
}

#zjzh .total-money > input {
	text-align: center;
}

#zjzh .total-money > i {
	display: inline-block;
	width: 45px;
	height: 24px;
	margin: 0 5px;
	background: url("~@/static/img/icon/transfer-arrow.webp") no-repeat 0 0 / cover;
	vertical-align: middle;
}

.refreesh_icon {
	width: 24px;
	height: 20px;
	cursor: pointer;
	vertical-align: bottom;
}

.roll-in-item-active {
	border: 1px solid red;
}

.all-btn:hover {
	cursor: pointer;
}

.refresh_money {
	width: 24px;
	height: 20px;
}

.refresh_money:hover {
	cursor: pointer;
}

/*去掉type为number带的箭头*/
#zjzh input[type="number"] {
	-moz-appearance: textfield;
	-webkit-appearance: none !important;
}

#zjzh input::-webkit-inner-spin-button {
	-webkit-appearance: none !important;
	margin: 0;
}

@keyframes refresh {
	from {
		transform: rotateZ(0deg);
	}
	to {
		transform: rotateZ(360deg);
	}
}

.refresh_anima {
	animation: refresh 0.5s ease-in-out 0s 1 alternate forwards;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/zjzh.vue